import { FileContent, FileContentFactory } from ".."

export interface CreatePromotionalContent {
    isDraft: boolean
    isActive: boolean
    media: FileContent
}

export class CreatePromotionalContentFactory {
    static create(): CreatePromotionalContent {
        return {
            isDraft: false,
            isActive: false,
            media: FileContentFactory.create(),
        }
    }
}
